// The Terms of Use page body. The text is src/content/terms.md, bundled as a
// string at build time, rendered by a deliberately tiny markdown renderer:
// headings, paragraphs, "-" lists and **bold**. Everything else is escaped,
// so the file can never inject HTML into the app.

import { TERMS_MD, TERMS_VERSION } from '../core/terms-text';
import { esc } from './ui';

export { TERMS_VERSION };
export const TERMS_LINK_TEXT = 'Terms of Use';
export const TERMS_AGREE_TEXT = 'I have read and agree to the Terms of Use';

import { renderMarkdown } from './markdown';

export { renderMarkdown };

/** The terms as HTML. The title line and the "Version" line are left out: the page shows them itself. */
export function termsBodyHtml(md: string = TERMS_MD) {
  const body = md.replace(/\r\n?/g, '\n').split('\n')
    .filter((l, i, all) => !(/^#\s/.test(l) && all.findIndex((x) => /^#\s/.test(x)) === i) && !/^Version\s/.test(l)).join('\n');
  return `<div class="terms">${renderMarkdown(body)}</div>`;
}

/** The version line shown above the terms. Members never see a draft or attorney label; termsIsDraft() is for the staff review page only. */
export function termsMetaHtml() {
  return `<div class="terms-meta"><span class="muted">Version ${esc(TERMS_VERSION)}</span></div>`;
}
